import { render } from "./TheBanner.pug?vue&type=template&id=02d1d4da&lang=pug"
import script from "./TheBanner.js?vue&type=script&lang=js"
export * from "./TheBanner.js?vue&type=script&lang=js"

import exportComponent from "/builds/projekte/pvp/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__